(function ($) {

	let script_loaded = false

	function loadScript() {
		if (script_loaded || $('script[src*="accesspointwidget/loader.js"]').length) {
			script_loaded = true
			return
		}
		let $script = $('<script src="https://www.ppl.cz/accesspointwidget/loader.js" async></script>')
		$("body").append($script)
		script_loaded = true
	}

	function isPPLSelected() {
		return $("[data-open-ppl-pickup-point]").length > 0
	}

	function maybePreloadScript() {
		if (isPPLSelected()) {
			loadScript()
		}
	}

	function getCurrentCountry() {
		const $countryInput = $('form#checkout__form select[name="shipping_country"], form#checkout__form input[name="shipping_country"]:checked, form#checkout__form input[name="shipping_country"]')
		const val = $countryInput.val()
		return val ? val.toUpperCase() : null
	}

	function get_ppl_config(country)
	{
		const config = {
			countriesMenuDisabled: true,
			langMenu: false
		}
		if (country) {
			country = country.toUpperCase();
			config.defaultCountry = country
			config.country = country
			config.allowedCountries = [country]
		}

		return config;
	}
	
	function find_widget()
	{
		return document.getElementById("pplWidget") || document.querySelector("ppl-access-point-widget")
	}

	function update_ppl_country(country) {
		if (!country) return
		const widget = find_widget();
		if (widget && typeof widget.configure === "function") {
			widget.configure(get_ppl_config(country))
		}
	}

	function init_ppl_widget() {
		const widget = find_widget()
		if (widget && !widget._pplInitialized) {
			widget._pplInitialized = true
			widget.addEventListener("ppl-accesspointwidget-select", function (e) {
				widgetCallback(e.detail)
			})
			widget.addEventListener("ppl-accesspointwidget-error", function (e) {
				console.error("PPL Widget Error:", e.detail)
			})
			
			if (typeof widget.configure === "function") {
				widget.configure(get_ppl_config(getCurrentCountry()))
			}
		}
		return widget
	}

	function openPickupWidget() {
		loadScript()

		const country = getCurrentCountry()
		const widget = init_ppl_widget();

		if (widget && typeof widget.open === "function") {
			if (typeof widget.configure === "function") {
				widget.configure(get_ppl_config(country))
			}
			widget.open()
		} else if (widget && window.customElements) {
			customElements.whenDefined("ppl-access-point-widget").then(function () {
				init_ppl_widget()
				if (typeof widget.configure === "function") {
					widget.configure(configUpdate)
				}
				if (typeof widget.open === "function") {
					widget.open()
				}
			})
		}
	}

	// Save selected store
	function widgetCallback(locationData) {
		if (locationData != null && typeof locationData !== "undefined") {
			var street = (locationData.address && locationData.address.street) ? locationData.address.street : (locationData.street || '')
			var city = (locationData.address && locationData.address.city) ? locationData.address.city : (locationData.city || '')
			var zip = (locationData.address && locationData.address.zipCode) ? locationData.address.zipCode : (locationData.zipCode || '')
			var name = locationData.name || ''
			var code = locationData.code || locationData.id || ''
			var type = locationData.type || locationData.accessPointType || ''

			// If DHL Packstation in Germany, ensure type is marked as ParcelBox
			if (!type || type.toLowerCase() === 'parcelshop') {
				if (name.toLowerCase().includes('packstation') || street.toLowerCase().includes('packstation')) {
					type = 'ParcelBox'
				}
			}

			$("input[name='shipping_pickup_point_id']").val(code) // for API we need code
			$("input[name='shipping_pickup_point_type']").val(type)
			$("input[name='shipping_company_name']").val(name)
			$("input[name='shipping_address_line_1']").val(street)
			$("input[name='shipping_city']").val(city)
			$("input[name='shipping_zip']").val(zip)

			$("input[name=shipping_method_id]").first().trigger("change")
			return true
		}

		return false
	}

	// Init widget open listener
	$(document).gp_ready(function () {

		init_ppl_widget()

		// Update PPL country when customer changes country in checkout
		$(document).off("change.ppl_country", 'select[name="shipping_country"], input[name="shipping_country"]').on("change.ppl_country", 'select[name="shipping_country"], input[name="shipping_country"]', function () {
			update_ppl_country($(this).val())
		})

		$("[data-open-ppl-pickup-point]").off("click").click(function (e) {
			e.preventDefault()

			// Open pickup point widget
			openPickupWidget()
		})

		maybePreloadScript()
	})

})(jQuery)